export const setCookie = (name, value, days) => {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (JSON.stringify(value) || "") + expires + "; path=/";
};

export const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
            try {
                return JSON.parse(c.substring(nameEQ.length, c.length));
            } catch (e) {
                return null;
            }
        }
    }
    return null;
};

export const addToHistory = (newItem) => {
    let currentHistory = [];
    try {
        currentHistory = JSON.parse(localStorage.getItem('bumpups_history')) || [];
    } catch (e) {
        currentHistory = [];
    }

    // Remove duplicates based on videoId
    const filteredHistory = currentHistory.filter(item => item.videoId !== newItem.videoId);
    // Add new item to the beginning
    const newHistory = [newItem, ...filteredHistory].slice(0, 10); // Keep last 10
    localStorage.setItem('bumpups_history', JSON.stringify(newHistory));
};

export const getHistory = () => {
    try {
        return JSON.parse(localStorage.getItem('bumpups_history')) || [];
    } catch (e) {
        return [];
    }
};
